import * as Yup from "yup"

export const FIELDS_NAME = {
   TRAILER_TYPE: "Trailer Type",
   PRIORITY: "Priority",
   NEXT_AVAILABLE_SLOT: "Next Available Slot",
   CUSTOMER_NAME: "Customer Name",
   PRODUCTION_LINE: "Production Line",
}

export const initialValues = {
   [FIELDS_NAME.PRIORITY]: "",
   [FIELDS_NAME.TRAILER_TYPE]: "",
   [FIELDS_NAME.NEXT_AVAILABLE_SLOT]: "",
   [FIELDS_NAME.CUSTOMER_NAME]: "",
   [FIELDS_NAME.PRODUCTION_LINE]: "",
}

export const getValidationSchema = (isProductionLineOptional = false) => {
   return Yup.object({
      [FIELDS_NAME.TRAILER_TYPE]: Yup.object()
         .nullable()
         .required("Select Trailer Type"),
      [FIELDS_NAME.PRIORITY]: Yup.object()
         .nullable()
         .required("Select Priority"),
      [FIELDS_NAME.NEXT_AVAILABLE_SLOT]: isProductionLineOptional
         ? Yup.object().nullable()
         : Yup.object().nullable().required("Select Available Slot"),
      [FIELDS_NAME.CUSTOMER_NAME]: Yup.object().nullable(),
      [FIELDS_NAME.PRODUCTION_LINE]: isProductionLineOptional
         ? Yup.object().nullable() // Optional when isProductionLineOptional is true
         : Yup.object().nullable().required("Production Line is required"), // Required otherwise
   })
}
